export default "__VITE_ASSET__ce265715__"